export default {
    text_0: "Feedback",
    text_1: "Nápady a hlásenie chýb",
    text_2: "Máš akýkoľvek nápad, ako DOFFERO zlepšiť alebo čo by ti pomohlo? Chceš nahlásiť nejakú chybu? Do toho. Najlepšie postrehy odmeníme.",
    text_3: "Vyplň, ak ťa môžeme kontaktovať pre viac informácií.",
    text_4: "Telefónne číslo (nepovinné)",
    text_5: "E-mail (nepovinné)",
    text_6: "Poznatky, postrehy, chyby",
    text_7: "Odoslať",
    text_8: "Treba zadať poznatky, postrehy, chyby.",
    text_9: "Feedback bol úspešne odoslaný. Ďakujeme.",
    text_10: "Vložte screenshot",
    text_11: "alebo",
    text_12: "Vybrať screenshot",
    text_13: "Vymazať",
    text_14: "Stiahnuť",
    text_15: "Naozaj chcete vymazať súbor?",
    text_16: "Je možné nahrať len 1 súbor.",
    text_17: "Iba {extensions} súbory môžu byť nahrané.",
    text_18: "{name} je príliš veľký! Prosím, vyberte súbor do veľkosti {fileMaxSize} MB.",
  
}